import React from 'react';

const Skills = (props) => {
    return (
        <section id="about" className="skill-bars">
            <div className="container">
                <div className="row">
                    <div className="col-md-8 col-md-offset-2 col-sm-10 col-sm-offset-1 text-center">
                        <h1>{props.data.title}</h1>
                        <p className="lead">
                            {props.data.description}
                        </p>
                    </div>
                </div>

                <div className="row">
                    {props.data.design ? 
                        (
                        <div className="col-md-6 col-sm-12">
                            <div className="skills-left skills">
                                <h3>Design</h3>
                                <ul className="skills-ul">
                                    {props.data.design.map((item, itemIndex) => {
                                        return (
                                            <li key={itemIndex}>
                                                <span>{item.title}</span>
                                                <div className="skill-bar-holder">
                                                    <div className={`skill-capacity ${item.rank}`}></div>
                                                </div>
                                            </li>
                                        );
                                    })
                                    }
                                </ul>
                            </div>
                        </div>
                        ) : null
                    }

                    {props.data.developing ? 
                        (
                        <div className="col-md-6 col-sm-12">
                            <div className="skills-right skills">
                                <h3>Developing</h3>
                                <ul className="skills-ul">
                                    {props.data.developing.map((item, itemIndex) => {
                                        return (
                                            <li key={itemIndex}>
                                                <span>{item.title}</span>
                                                <div className="skill-bar-holder">
                                                    <div className={`skill-capacity ${item.rank}`}></div>
                                                </div>
                                            </li>
                                        );
                                    })
                                    }
                                </ul>
                            </div>
                        </div>
                        ) : null
                    }
                </div>                    
            </div>
        </section>
    )
}

export default Skills;